import { AfterViewInit, AfterViewChecked, Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appStickyHeaders]'
})
export class StickyHeadersDirective implements AfterViewInit, AfterViewChecked {

  constructor() { }

  // adjustStickyTitleBar after view init
  public ngAfterViewInit() {
    this.adjustStickyTitleBar();
    this.adjustExtendedSpaces();
  }

  // adjustStickyTitleBar and extended spaces on window resize
  @HostListener('window:resize', ['$event'])
  onresize($event) {
    this.adjustStickyTitleBar();
    this.adjustExtendedSpaces();
  }

  // adjustStickyTitleBar on window scroll
  @HostListener('window:scroll', ['$event'])
  onScroll($event) {
    this.adjustStickyTitleBar();
  }

  // adjustStickyTitleBar after view checked (e.g. user minimizes the table of contents)
  public ngAfterViewChecked() {
    this.adjustStickyTitleBar();
    this.adjustExtendedSpaces();
  }

  private adjustStickyTitleBar() {
    // determine proper sticky header offset
    const headerDiv = $('.sticky-header-offset')[0];
    const stickyHeaderOffset = headerDiv.offsetTop + headerDiv.offsetHeight;

    // toggle sticky class on each 'title-bar'
    $('.page').each((index, element) => {
      const $titleBar = $(element).find('.title-bar');
      const br = element.getBoundingClientRect();
      $titleBar.toggleClass('sticky', br.top < stickyHeaderOffset && br.bottom > stickyHeaderOffset);
    });

    // adjust margin-top of sticky title-bar
    $('.title-bar.sticky').css('margin-top', (stickyHeaderOffset - 1) + 'px'); // slide it up 1px to look better
  }

  /**
   * adjust the extendedSpaces height, for the default 1000px seems too much in most times.
   */
  private adjustExtendedSpaces() {
    // viewport height (i.e. of whole app view window) and details content div header
    const viewportHeight: number = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const headerDiv = $('.sticky-header-offset')[0];

    // contentTopLoc (i.e. header's bottom location in the viewport)
    const contentTopLoc: number = headerDiv.offsetTop + headerDiv.offsetHeight;

    // extended spaces div height reset
    const exetendedSpacesDiv: HTMLElement = document.getElementById('extendedSpaces') ;
    if (exetendedSpacesDiv) {
      if (viewportHeight > contentTopLoc)  {
        // height for displaying content
        const heightForContent = viewportHeight - contentTopLoc;

        // last element height
        const lastElementHeight: number = $('.page').last()[0].getBoundingClientRect().height;

        // reset the extended spaces div height
        if (lastElementHeight <= heightForContent) {
          exetendedSpacesDiv.style.height = (heightForContent - lastElementHeight + 10) + 'px';  // add 10px more (maybe not necessary)
        } else {
          exetendedSpacesDiv.style.height = 0 + 'px';
        }
      } else {
        exetendedSpacesDiv.style.height = 0 + 'px';
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/sticky-headers.directive.ts